import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { logOut } from "../../modules/App/state/actions";
import User from "./User";
import TenantSwitcher from "./TenantSwitcher";
import "./HeaderTemplate.scss";
import {LogoNew} from "../../icons/LogoNew";

export const HeaderTemplate = ({ center }) => {
    const dispatch = useDispatch();

    const handleExit = useCallback(
        () => {
            dispatch(logOut());
        },
        [ dispatch ]
    );

    return (
        <header className="page-header">
            <LogoNew className="page-header__logo" />

            <div>{center}</div>

            <div>
                <TenantSwitcher />

                <User onExit={handleExit} />
            </div>
        </header>
    );
};

HeaderTemplate.propTypes = { center: PropTypes.node };
